export class Colors {
  static readonly QWILT_BLUE_DIM = "#1F7CB0";
  static readonly QWILT_BLUE_BRIGHT = "#2EA9EE";
  static readonly QWILT_GREEN_DIM = "#60AD24";
  static readonly QWILT_GREEN_BRIGHT = "#84ED35";
  static readonly QWILT_RED_DIM = "#B60000";
  static readonly QWILT_RED_BRIGHT = "#F80000";
  static readonly QWILT_YELLOW_DIM = "#B8B826";
  static readonly QWILT_YELLOW_BRIGHT = "#FEFB38";

  static readonly INACTIVE_RED = "#ff2254";
  static readonly DAMAGED_ORANGE = "#ffa022";
  static readonly HEALTHY_GREEN = "#00ff84";

  static readonly SELECTED_BLUE = "#0db2f6";
  static readonly LIGHTISH_BLUE = "#407bfb";
  static readonly BABY_BLUE = "#9ce4ff";
  static readonly CYAN = "#00f3ea";

  static readonly MARINE = "#07394c";
  static readonly NAVY = "#01222f";
  static readonly NAVY_TWO = "#002736";
  static readonly NAVY_THREE = "#022e3f";
  static readonly TWILIGHT_BLUE = "#0e4960";
  static readonly LIGHT_NAVY = "#1a6c8b";
  static readonly DUSTY_BLUE = "#5691a7";
  static readonly FADED_BLUE = "#65a3bb";
  static readonly LIGHT_GREY_BLUE = "#97c5d7";
  static readonly PALE_GREY = "#e2e9eb";
  static readonly PALE_GREY_TWO = "#f7fafb";
  static readonly ICE_BLUE = "#eaf9ff";
  static readonly CUSTOM_GREY = "#ECF0F1";
  static readonly WHITE = "#ffffff";
  static readonly DISABLED = "#b6b8b9";
}



// WEBPACK FOOTER //
// ./app/styling/colors.ts